import GridItem from "./grid-item/GridItem";
import {ChannelSectionProps, EventPlatformEntry} from "@mediaspace/shared/types";
import styled from "@emotion/styled";
import {Pagination} from "@kaltura/ds-react-components";
import {usePagination} from "@mediaspace/hooks/usePagination";
import {Box} from "@mediaspace/shared/styled";
import {useEffect} from "react";

export interface MediaGridProps extends ChannelSectionProps<EventPlatformEntry[]> {
    playlistId?: string;
    showPagination?: boolean;
    itemsPerPage?: number;
    analyticsValue?: string;
    page?: number;
}

const StyledMediaGrid = styled(Box)(({ theme }) => ({
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: theme.spacing(4),
    [theme.breakpoints.down(theme.breakpoints.values.lg)]: {
        gap: theme.spacing(2),
    },
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
        display: "block"
    }
}));

const StyledPagination = styled(Pagination)(({ theme }) => ({
    marginTop: theme.spacing(2)
}));

const baseClass = "kms-ds-media-grid";

/**
 * media grid
 */
const MediaGrid = (props: MediaGridProps) => {

    const {categoryId, content, playlistId = "", showPagination, itemsPerPage = 50, analyticsValue, page = 1} = props;

    const [itemsToShow, currentPage, handlePagination] = usePagination(content, itemsPerPage);

    const shouldShowPagination = showPagination && (itemsPerPage < content.length);

    const mediaToShow = shouldShowPagination ? itemsToShow : content;

    useEffect(() => {
        if (page > 1) {
            handlePagination(null, page);
        }
    }, []);

    return (
        <>
            <StyledMediaGrid className={`${baseClass}-wrapper`}>
                {mediaToShow.map((entry, index) => (
                    <GridItem
                        name={entry.name}
                        duration={entry.duration}
                        image={entry.thumbnailUrl}
                        entryId={entry.id}
                        entryType={entry.type}
                        categoryId={categoryId}
                        playlistId={playlistId}
                        key={`grid-item-${entry.id}-${index}`}
                        analyticsName={analyticsValue as string}
                    />
                ))}
            </StyledMediaGrid>

            {shouldShowPagination && (
                <StyledPagination
                    className={`${baseClass}-pagination`}
                    page={currentPage}
                    count={Math.ceil(content.length / itemsPerPage)}
                    onChange={handlePagination}
                />
            )}
        </>

    );
};

export default MediaGrid;
